import { useTranslation } from 'react-i18next';
import { useSiteImage } from '@/hooks/useSiteImage';
import ThreeStepBuyBox from './ThreeStepBuyBox';

export default function HeroBanner() {
  const { t } = useTranslation();
  const imageUrl = useSiteImage('threeStep.hero.image', 'https://public.readdy.ai/ai/img_res/fd7e2a14-72d7-4f75-9e0c-3360a4792f07.png');

  return (
    <section id="three-step-hero" className="relative w-full bg-[#141313] overflow-hidden">
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(60%_70%_at_80%_30%,rgba(123,17,19,0.28),transparent_70%),radial-gradient(50%_60%_at_10%_90%,rgba(27,58,92,0.22),transparent_70%)]" />
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#C9A27A]/40 to-transparent" />

      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-10 pt-24 pb-14 md:pt-28 md:pb-20 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        <div className="flex flex-col items-center lg:items-start text-center lg:text-left gap-5 order-1">
          <div className="flex items-center gap-3">
            <div className="w-8 h-px bg-[#C9A27A]" />
            <span className="text-[11px] tracking-[0.24em] uppercase text-[#C9A27A] font-medium">{t('threeStep.hero.label')}</span>
            <div className="w-8 h-px bg-[#C9A27A] lg:hidden" />
          </div>

          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.08] text-balance">{t('threeStep.hero.heading')}</h1>

          <p className="text-[15px] text-white/50 font-light tracking-wide max-w-md">{t('threeStep.hero.subtitle')}</p>

          <div className="flex items-center gap-5 mt-1">
            {[
              { num: '01', label: 'OPEN', color: 'border-[#4F7BAA] text-[#8DB3DB]' },
              { num: '02', label: 'TREAT', color: 'border-[#B0393C] text-[#E88A8C]' },
              { num: '03', label: 'LOCK', color: 'border-[#3F8F6B] text-[#86D1AE]' },
            ].map((step) => (
              <div key={step.num} className="flex flex-col items-center gap-1.5">
                <span className={`w-11 h-11 rounded-full border ${step.color} flex items-center justify-center text-[13px] font-semibold`}>{step.num}</span>
                <span className="text-[10px] tracking-[0.18em] uppercase text-white/45 font-medium">{step.label}</span>
              </div>
            ))}
          </div>

          {/* Product shot sits between the steps and the buy box on phones */}
          <div className="lg:hidden w-full max-w-sm mt-2">
            <img src={imageUrl} alt="Rx.K Seoul 3-Step Daily Treatment" className="w-full h-auto object-contain drop-shadow-[0_30px_40px_rgba(0,0,0,0.5)]" />
          </div>

          <div className="w-full mt-3 flex justify-center lg:justify-start">
            <ThreeStepBuyBox align="left" />
          </div>
        </div>

        <div className="hidden lg:flex justify-center order-2">
          <div className="relative w-full max-w-lg">
            <div className="absolute inset-8 rounded-full bg-[#7B1113]/25 blur-3xl" />
            <img src={imageUrl} alt="Rx.K Seoul 3-Step Daily Treatment" className="relative w-full h-auto object-contain drop-shadow-[0_40px_50px_rgba(0,0,0,0.55)]" />
          </div>
        </div>
      </div>
    </section>
  );
}
